  <template>
  <div class="field href-url">
    <span v-if="label" class="label text-right" :class="labelClass">
      {{ label }}
    </span>

    <div class="value v-align" :class="valueClass">
      <a :href="href" :title="title" target="_blank">
        {{ value }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String
    },
    label: String,
    title: String,
    mailto: Boolean,
    width: String
  },

  computed: {
    href: function () {
      if (this.value) {
        let prefix = ''

        if (!this.value.includes('http')) prefix = '//'

        if (this.mailto) {
          prefix = 'mailto:'
        }

        return prefix + this.value
      }
    },

    valueClass: function () {
      if (this.label) {
        return 'col-8'
      }
    },

    labelClass: function () {
      if (this.width === 'large') {
        return 'col-2'
      } else {
        return 'col-4'
      }
    }
  }
}
</script>
